/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.pageModule')
.controller('QuestionPanelController', ['BulbPageService', QuestionPanelController]);

/**
* AngularJS controller for the question panel.
*/
function QuestionPanelController(BulbPageService) {
  var that = this;

  this.page = BulbPageService.page;

  this.autoSaveOptions = {
    restId: that.page.unit.id,
    restCollection: 'units'
  };
}



